/**
 * This helper can accept multiple concurrent callbacks. Only the first
 * one will be executed. The remaining ones will wait for the first one
 * to finish and return its result. It allows us not to do the same
 * thing more than once (e.g. in case of multiple concurrent requests such
 * as refreshing access tokens).
 */

export class ConcurrentCallbacksReducer<T> {
  private pendingCallback: Promise<T>;

  constructor() {
    this.pendingCallback = null;
    this.reduce = this.reduce.bind(this);
  }

  async reduce (callback: () => Promise<T>) {
    if (this.pendingCallback) {
      return this.pendingCallback;
    } else {
      this.pendingCallback = callback();
      const result = await this.pendingCallback;
      this.pendingCallback = null;
      return result;
    }
  }
}
